import scroll from './scroll.js';
import search from './search.js';

scroll();
search();